import { useEffect, useState } from "react";
import { colors } from "../../js/generateSchedule";
import { getClass, getUsers } from "../../js/database";
import AssignmentEntry from "./AssignmentEntry";


function ClassModals({classes, homework}) {
    const [classIds, setClassIds] = useState(["Lunch", "MX"]);
    const [classInfo, setClassInfo] = useState(0);
    const [showMembers, setShowMembers] = useState(false);
    const [users, setUsers] = useState(0);
    useEffect(() => {
        Object.entries(classes.classes).map((c) => c[1].id).forEach((c) => {
            setClassIds((classIds) => {
                if (classIds.includes(c)) return classIds;
                classIds.push(c);
                return classIds;
            })
        })
        if (!classes.settings.local) {
        var cinfoPromises = []
        classIds.forEach((c) => {
            if (c === "Lunch" || c === "MX") return;
            cinfoPromises.push(getClass(c));
        })

        Promise.all(cinfoPromises).then((cinfo) => {
            var cinfoObj = {};
            cinfo.forEach((c, i) => {
                c[1].showMembers = false;
                cinfoObj[c[0]] = c[1];
            })
          //  console.log(cinfoObj);
            setClassInfo(cinfoObj);
        })
        getUsers().then((users) => {
            setUsers(users);
        })
    }
    }, [])

    return (
        classIds.map((c, cId) => (
            <div class="modal fade" id={c.replaceAll(" ", "").replaceAll("'", "").replaceAll(":", "").replaceAll("&", "")} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content bg-dark">
                <div class="modal-header">
                <h5>{c.split(" ").slice(0, -1).join(" ") || c}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                {classInfo.hasOwnProperty(c) &&
                        <div className="">
                            <h4 className="text-center">Class Info</h4>
                            <div className="text-center">
                            <h5 class="mt-2 text-center">Members</h5>
                        {classInfo !== 0 && showMembers &&
                        
                        <ul>
                            {Object.keys(classInfo[c].users).map((m) => (
                                <li className="text-center">{users[m].info.name}</li>
                            ))}
                        </ul>
                        }
                        <button class="btn btn-primary mx-auto text-center" onClick={() => {setShowMembers((showMembers) => {
                            return !showMembers;
                        })}}>{showMembers ? "Hide" : "Show"} Members</button>
                        </div></div>}
                        {c !== "Lunch" && c !== "MX" && (homework !== 0 && homework.hasOwnProperty(c)) && <h4 className="text-center mt-3">Homework</h4>}
                        {(homework !== 0 && homework.hasOwnProperty(c)) &&
                    <div class="d-flex">
                        
                        <ul class="mx-auto row justify-content-center">


                            {homework !== 0 && homework.hasOwnProperty(c)?  Object.entries(homework[c].hw).length > 0 ? Object.entries(homework[c].hw).sort((a, b)=> new Date(a[0]).getTime() -new Date(b[0]).getTime()).map(([date, assignments], i) => (
             
              <li key={date+cId+i}><div class="card mt-2 mx-auto " style={{width: "20rem", backgroundColor:colors[homework[c].block]}}>
                        <div class="card-body">
                        <h5 class="card-title text-center">{date}</h5>
                        

                          {assignments.map((a) => (
                            typeof a === "string" ? <p class="card-text pb-0 mb-0">{a}</p> :
                            <AssignmentEntry assignment={{entry:a.entry, desc:a.desc, c:homework[c].block, date:date, className:c.split(" ").slice(0, -1).join(" ")}}/>
                          ))}
                    

                    </div>
          </div></li>)) : <li key={cId+"nohw"}>
          <div class="card mt-2" style={{width: "20rem", backgroundColor:colors[homework[c].block]}}>
                        <div class="card-body">
                        <p class="card-text text-center">No Homework!</p>

                        
                    

                    </div>
            </div>
          </li> : <p>Loading</p>}
                        </ul>
                    </div>}
                </div>
                </div>
            </div>
            </div>
        )))
    
//     return (<div>
//     {Object.entries(homework).map((c) => (
//         <div class="modal fade" id={c[0].replaceAll(" ", "")} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
//         <div class="modal-dialog">
//           <div class="modal-content bg-dark">
//             <div class="modal-header">
//               <h5 class="modal-title" id="exampleModalLabel">{c[0].split(" ").slice(0, -1).join(" ") || c[0]}</h5>
//             </div>
//             <div class="modal-body">
//               <div class="d-flex">
//         <ul class="mx-auto justify-content-center">
//             <p>{JSON.stringify(homework)}</p>
//           {Object.entries(c[1].hw).map(([date, assignments]) => (
//               <li key={date}><div class="card mt-4" style={{width: "20rem", backgroundColor:colors[c[1].block]}}>
//                         <div class="card-body">
//                         <h5 class="card-title text-center">{date}</h5>
                        

//                           {assignments.map((a) => (
//                             <p class="card-text pb-0 mb-0">{a}</p>
//                           ))}
                    

//                     </div>
//           </div></li>))}
// {/* 
//             //   <li><div class="card mt-4" style="width: 20rem; background-color: <%= colors[v.block] %>">
//             //             <div class="card-body">
//             //             <h5 class="card-title text-center">No Homework!</h5>
//             //         </div>
//             //   </div></li> */}

//         </ul>
//   </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     ))}
//     </div>
//     )
//     ;
}
export default ClassModals;